import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { useConfig } from '../../config';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { navigateToSitecorePage, skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.HusOgHytteGlasskadeVinduEllerDor,
        tekst: 'Glass i vindu eller dør',
    },
    {
        id: KategoriSvarId.HusOgHytteGlasskadeSanitarporselenEllerDusjvegg,
        tekst: 'Sanitærporselen eller dusjvegg',
    },
    {
        id: KategoriSvarId.HusOgHytteGlasskadePlatetoppEllerKomfyr,
        tekst: 'Glass i platetopp eller komfyr',
    },
    {
        id: KategoriSvarId.HusOgHytteGlasskadeAnnen,
        tekst: 'Annen glasskade',
    },
];

export const BygningGlasskade = () => {
    const { url } = useConfig().links.husoghyttelandingsside;
    const navigate = useNavigate();

    const onNext = (svarId: string) => {
        if (svarId === KategoriSvarId.HusOgHytteGlasskadeVinduEllerDor) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningGlasskadeVinduDor));
        } else if (svarId === KategoriSvarId.HusOgHytteGlasskadeSanitarporselenEllerDusjvegg) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningGlasskadeSanitarporselenDusjvegg));
        } else if (svarId === KategoriSvarId.HusOgHytteGlasskadePlatetoppEllerKomfyr) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningGlasskadeIPlatetoppKomfyr));
        } else if (svarId === KategoriSvarId.HusOgHytteGlasskadeAnnen) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningGlasskadeAnnen));
        }
    };

    return (
        <GruppeLandingsside
            title="Glasskade"
            onNext={onNext}
            radioButtonsLabel="Hva gjelder det?"
            navigateToParent={() => navigateToSitecorePage(url)}
            alternativer={alternativer}
            svgCardType={SvgCardType.HusEnkelt}
            kategoriId="bygning-glasskade"
        />
    );
};
